import { FC } from "react";
import { useTrans } from "../../../hooks";
import {
    Internship,
    InternshipSchedule,
    InternshipScheduleSeat,
    School,
    Training,
    TrainingYear,
    Typology,
} from "../../../apis";
import {
    Text,
    VStack,
    Divider,
    Table,
    TableContainer,
    Thead,
    Tr,
    Th,
    Tbody,
    Td,
    HStack,
} from "@chakra-ui/react";
import { AppRenderDetailItem } from "../../../components";
import { APPC, UTIL } from "../../../config";

export const SchedulerDetailView: FC<{
    data: InternshipSchedule;
}> = ({ data }) => {
    const { t } = useTrans();
    const dayjs = UTIL.getDayJs();

    return (
        <>
            <VStack gap={4} alignItems={"stretch"}>
                <VStack w={"full"} gap={8}>
                    <HStack w={"full"} justifyContent={"space-between"} gap={6}>
                        <AppRenderDetailItem
                            label={t("ent.Internship:name.label")}
                            value={(data.internship as Internship)?.name || ""}
                        />
                        <AppRenderDetailItem
                            label={t("ent.Internship:training.label")}
                            value={
                                (
                                    (data.internship as Internship)
                                        ?.training as Training
                                )?.name || ""
                            }
                        />
                        <AppRenderDetailItem
                            label={t("ent.Internship:typology.label")}
                            value={
                                (
                                    (data.internship as Internship)
                                        ?.typology as Typology
                                )?.name || ""
                            }
                        />
                        <AppRenderDetailItem
                            label={t(
                                "ent.InternshipSchedule:trainingYear.label"
                            )}
                            value={`${(data.trainingYear as TrainingYear)?.code} - ${(data.trainingYear as TrainingYear)?.year}`}
                        />
                    </HStack>
                    <HStack w={"full"} justifyContent={"space-between"} gap={6}>
                        <AppRenderDetailItem
                            label={t("ent.InternshipSchedule:name.label")}
                            value={data.name}
                        />
                        <AppRenderDetailItem
                            label={t("ent.InternshipSchedule:capacity.label")}
                            value={`${data.totalUsedSeats} / ${data.capacity}`}
                        />
                        <AppRenderDetailItem
                            label={t("ent.InternshipSchedule:startDate.label")}
                            value={dayjs
                                .utc(data.startDate)
                                .format(APPC.APP_DATE_FORMAT)}
                        />
                        <AppRenderDetailItem
                            label={t("ent.InternshipSchedule:endDate.label")}
                            value={dayjs
                                .utc(data.endDate)
                                .format(APPC.APP_DATE_FORMAT)}
                        />
                    </HStack>
                </VStack>

                <Divider borderColor={"var(--chakra-colors-primaryT70)"} />
                <Text textStyle={"semiBoldLg"}>
                    {t("padm.InternshipScheduleSeatPage:text.pageTitle")}
                </Text>
                <TableContainer>
                    <Table>
                        <Thead>
                            <Tr>
                                <Th>
                                    {t(
                                        "padm.InternshipScheduleSeatPage:text.school"
                                    )}
                                </Th>
                                <Th isNumeric>
                                    {t(
                                        "padm.InternshipScheduleSeatPage:text.schoolSeats"
                                    )}
                                </Th>
                                <Th isNumeric>
                                    {t(
                                        "padm.InternshipScheduleSeatPage:text.assignToStudent"
                                    )}
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {(
                                data?.internshipScheduleSeats as InternshipScheduleSeat[]
                            )?.map((s) => {
                                return (
                                    <Tr key={s.id}>
                                        <Td>{(s.school as School).name}</Td>
                                        <Td isNumeric>{Number(s.noOfSeats)}</Td>
                                        <Td isNumeric>
                                            {Number(s.noOfAssignedSeats)}
                                        </Td>
                                    </Tr>
                                );
                            })}
                        </Tbody>
                    </Table>
                </TableContainer>
            </VStack>
        </>
    );
};
